import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { BarChart3 } from "lucide-react";

const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString([], { month: "short", day: "numeric" });

export const TextingReport = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/sms/report").then((r) => setRows(r.data.weeks)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <Card className="mb-5 overflow-hidden" data-testid="texting-report">
      <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3">
        <BarChart3 className="h-4 w-4 text-amber-600" /><h3 className="font-semibold text-slate-900">Weekly texting report</h3>
        <span className="text-xs text-slate-400">weeks start Monday (Eastern)</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr><th className="px-5 py-2">Week of</th><th className="px-3 py-2">Leads texted</th><th className="px-3 py-2">Texts sent</th><th className="px-3 py-2">Leads replied</th><th className="px-3 py-2">Reply rate</th><th className="px-3 py-2">Booked by text</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((w) => (
              <tr key={w.week_start} data-testid={`texting-week-${w.week_start}`}>
                <td className="px-5 py-2 font-medium text-slate-900">{fmt(w.week_start)}</td>
                <td className="px-3 py-2">{w.leads_texted}</td><td className="px-3 py-2">{w.texts_sent}</td>
                <td className="px-3 py-2">{w.leads_replied}</td><td className="px-3 py-2">{w.reply_rate}%</td>
                <td className="px-3 py-2 font-semibold text-emerald-700">{w.booked}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
